// ─── TEMPORARY superadmin console ─────────────────────────────────────────────
// Everything this console needs lives inside src/views/superadmin/, endpoints
// included, so the whole thing can be dropped by deleting this folder plus the
// two SuperadminRoutes lines in src/router/routes/index.jsx. Nothing outside
// this folder imports from it.
//
// The endpoints, in the order the flow walks them: make an ops account, make a
// brand, make that brand's two logins, then raise an invoice for one of its
// publishers. Paths are relative to themeConfig.apiUrl.base (<host>/api) —
// every call uses `useAxios({ base: "base" })`, which attaches the session's
// bearer token.
export const SUPERADMIN_ENDPOINTS = {
    // Open on purpose: it bootstraps the very first ops user, which by
    // definition happens with no session in hand.
    OPS_ACCOUNTS: "/ops/v1",
    // The list's rows carry the `api_key` and `ext_id` that holder create is
    // built from.
    BRANDS      : "/onboarding/account/v1",
    // Takes an *array* — one brand's admin and publisher go up in a single call.
    HOLDERS     : "/onboarding/holder/v1",
    // Scoped to one brand by path, so the list cannot be asked for until a
    // brand is chosen — which is also what supplies the invoice's api_key.
    AFFILIATES  : (accountId) => `/brands/v1/accounts/${accountId}/affiliates/public`,
    // Authenticated by `?api_key=`, the brand's key — not by the bearer.
    INVOICES    : "/invoices/v1"
};

export const SUPERADMIN_TABS = [
    { key: "ops", label: "1 · Ops account" },
    { key: "brands", label: "2 · Brands" },
    { key: "holders", label: "3 · Brand logins" },
    { key: "invoices", label: "4 · Invoices" }
];

export const TAB = {
    OPS     : "ops",
    BRANDS  : "brands",
    HOLDERS : "holders",
    INVOICES: "invoices"
};

// The two sides of a brand's login: `admin` signs into the brand workspace,
// `affiliate` into the publisher one (the UI elsewhere says "publisher").
export const HOLDER_TYPE = {
    ADMIN    : "admin",
    AFFILIATE: "affiliate"
};

export const HOLDER_TYPE_LABEL = {
    [HOLDER_TYPE.ADMIN]    : "Brand admin",
    [HOLDER_TYPE.AFFILIATE]: "Publisher"
};

export const RECORD_STATUS = {
    ACTIVE  : "active",
    INACTIVE: "inactive"
};

export const RECORD_STATUS_OPTIONS = [
    { value: RECORD_STATUS.ACTIVE, label: "Active" },
    { value: RECORD_STATUS.INACTIVE, label: "Inactive" }
];

export const RECORD_STATUS_TONE = {
    [RECORD_STATUS.ACTIVE]  : "success",
    [RECORD_STATUS.INACTIVE]: "destructive",
    disabled                : "destructive"
};

export const RECORD_STATUS_LABEL = {
    [RECORD_STATUS.ACTIVE]  : "Active",
    [RECORD_STATUS.INACTIVE]: "Inactive",
    disabled                : "Disabled"
};

export const ONBOARD_VIA = "api";
export const DEFAULT_KYC_WINDOW = 30;

export const AFFILIATES_DEFAULT_LIMIT = 20;
export const AFFILIATES_MAX_LIMIT = 100;

// This endpoint speaks in upper case (kyc_status=VERIFIED, payout_status=
// ELIGIBLE) where the rest of the app uses lower — so the filters carry their
// own options rather than borrowing the shared ones, and every status read back
// off a row is lowercased before it is looked up for a label or a tone.
export const AFFILIATE_KYC_STATUS_OPTIONS = [
    { value: "NOT_STARTED", label: "Not started" },
    { value: "IN_PROGRESS", label: "In progress" },
    { value: "DOCUMENTS_RECEIVED", label: "Documents received" },
    { value: "VERIFIED", label: "Verified" },
    { value: "REJECTED", label: "Rejected" }
];

export const AFFILIATE_PAYOUT_STATUS_OPTIONS = [
    { value: "ELIGIBLE", label: "Eligible" },
    { value: "NOT_ELIGIBLE", label: "Not eligible" }
];

export const statusKey = (value) => String(value || "").toLowerCase();

// formatCurrency only knows these two symbols, so the form offers only these.
export const CURRENCY_OPTIONS = [
    { value: "INR", label: "INR ₹" },
    { value: "USD", label: "USD $" }
];

// The invoice's due date sits this far past its issue date by default — the
// gap in the sample payload (12 Sep → 27 Sep).
export const DEFAULT_INVOICE_TERM_DAYS = 15;
